var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleMissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.125C4.6125 1.125 1.125 4.6125 1.125 9C1.125 13.3875 4.6125 16.875 9 16.875C13.3875 16.875 16.875 13.3875 16.875 9C16.875 4.6125 13.3875 1.125 9 1.125ZM12.0375 12.9375L9 9.9L5.9625 12.9375L5.0625 12.0375L8.1 9L5.0625 5.9625L5.9625 5.0625L9 8.1L12.0375 5.0625L12.9375 5.9625L9.9 9L12.9375 12.0375L12.0375 12.9375Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleMissed);
export default __webpack_public_path__ + "static/media/CircleMissed.73a2a0bd09be2096c7a80f391a67862e.svg";
export { ForwardRef as ReactComponent };